import { render, staticRenderFns } from "./MyInfo.vue?vue&type=template&id=04e72c72&scoped=true&"
import script from "./MyInfo.vue?vue&type=script&lang=js&"
export * from "./MyInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04e72c72",
  null
  
)

export default component.exports